import posthog from "posthog-js";

/** Public PostHog project token (safe to ship in browser code). */
const POSTHOG_TOKEN = "phc_qnvM7bSgvtEywc8cjbcQ4UoMad5LouyuVHzcp8WBE9y8";

let initialised = false;

export function initPostHog() {
  if (initialised || typeof window === "undefined") return;
  initialised = true;
  try {
    posthog.init(POSTHOG_TOKEN, {
      api_host: "https://eu.i.posthog.com",
      person_profiles: "identified_only",
      capture_pageview: "history_change",
      capture_exceptions: true,
      session_recording: { maskAllInputs: true },
    });
    posthog.register({ brand: "crs", app: "ops_hub" });
  } catch {
    /* never break the site over analytics */
  }
}

// Initialise as soon as this module loads in the browser (before React renders).
initPostHog();

export function phCapture(event: string, properties: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  try {
    posthog.capture(event, properties);
  } catch {
    /* ignore */
  }
}

export function phCaptureException(error: unknown, properties: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  try {
    posthog.captureException(error, properties);
  } catch {
    /* ignore */
  }
}

export function phSaveFailed(action: string, error: unknown) {
  const message = error instanceof Error ? error.message : String(error ?? "Unknown error");
  phCapture("save_failed", { action, error_message: message.slice(0, 300) });
}
